// import Vue from 'vue'
import { DEVICE_TYPE } from '@/utils/device'
import { mapState } from 'vuex'
import moment from 'moment'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
// const mixinsComputed = Vue.config.optionMergeStrategies.computed
// const mixinsMethods = Vue.config.optionMergeStrategies.methods

const mixin = {
  computed: {
    ...mapState({
      layoutMode: state => state.app.layout,
      navTheme: state => state.app.theme,
      primaryColor: state => state.app.color,
      colorWeak: state => state.app.weak,
      fixedHeader: state => state.app.fixedHeader,
      fixSiderbar: state => state.app.fixSiderbar,
      fixSidebar: state => state.app.fixSiderbar,
      contentWidth: state => state.app.contentWidth,
      autoHideHeader: state => state.app.autoHideHeader,
      sidebarOpened: state => state.app.sidebar,
      multiTab: state => state.app.multiTab
    })
  },
  methods: {
    isTopMenu () {
      return this.layoutMode === 'topmenu'
    },
    isSideMenu () {
      return !this.isTopMenu()
    }
  }
}

const mixinDevice = {
  computed: {
    ...mapState({
      device: state => state.app.device
    })
  },
  methods: {
    isMobile () {
      return this.device === DEVICE_TYPE.MOBILE
    },
    isDesktop () {
      return this.device === DEVICE_TYPE.DESKTOP
    },
    isTablet () {
      return this.device === DEVICE_TYPE.TABLET
    }
  }
}

const mixinLocale = {
  data () {
    return {
    }
  },
  computed: {
    'locale' () {
      const lang = this.$store.getters.lang
      if (lang === 'en_US') {
        return null
      } else {
        return zhCN
      }
    }
  },
  mounted () {
  },
  methods: {
    moment,
    changeLocale (lang) {
    }
  }
}

const mixinPagination = {
  data () {
    return {
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showQuickJumper: true,
        hideOnSinglePage: false,
        showSizeChanger: true,
        showTotal: this.showTotal,
        onChange: this.changePage,
        onShowSizeChange: this.changePageSize
      }
    }
  },
  methods: {
    changePage (current, pageSize) {
      Object.assign(this.pagination, { current })
      this.getList()
    },
    changePageSize (current, pageSize) {
      Object.assign(this.pagination, { pageSize, current: 1 })
      this.getList()
    },
    showTotal (total, range) {
      return this.$t('custom.pagination.total', { total })
    }
  }
}

export { mixin, mixinDevice, mixinLocale, mixinPagination }
